import { render, staticRenderFns } from "./ShowBuilding.vue?vue&type=template&id=7c0ac522"
import script from "./ShowBuilding.vue?vue&type=script&lang=js"
export * from "./ShowBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports